/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Area_No_GeoInputs */

const vi_care_log_area_no_geo = /** @type {(inputs: Care_Log_Area_No_GeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vùng này chưa có toạ độ trên bản đồ`)
};

/**

* @param {Care_Log_Area_No_GeoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_area_no_geo = /** @type {((inputs?: Care_Log_Area_No_GeoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Area_No_GeoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_area_no_geo(inputs)
});